import type { MessageBundle } from "../i18n";

export const audioMessages: MessageBundle<"audio.mute" | "audio.unmute"> = {
  en: { "audio.mute": "Sound off", "audio.unmute": "Sound on" },
  ru: { "audio.mute": "Выключить звук", "audio.unmute": "Включить звук" },
  uk: { "audio.mute": "Вимкнути звук", "audio.unmute": "Увімкнути звук" },
};
